import { initializeReactWidget } from "~/common/widgets/frontend";
import config from "./widget.json";
import { Search } from "./components/Search";

// the widget class name is used to identify elements to attach our React component to
// the php widget file uses this same value when rendering the widget container
const widgetClassName = config.name;
initializeReactWidget(widgetClassName, Search, Search); // edit and view use the same component
